<template>
  <q-markup-table
    separator="cell"
    flat
    bordered
    dense
  >
    <thead>
      <tr>
        <th>
          Payments
          <q-chip
            v-if="paymentDate"
            square
            size="sm"
            dense
          >
            {{ $d(paymentDate, 'longDate') }}
            <q-tooltip>
              Effective Date
            </q-tooltip>
          </q-chip>
        </th>
        <th>Time</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="paymentDatum in paymentData"
        :key="paymentDatum.label"
      >
        <td class="sub-label">
          <div
            class="ellipsis"
            style="max-width: 255px;"
          >
            {{ paymentDatum.label }}
          </div>
        </td>
        <td class="sub-label">
          <formatted-date
            :value="paymentDatum.time"
            format="icon"
          />
        </td>
        <td class="cell-value">
          <formatted-number :value="paymentDatum.value" />
          <q-tooltip
            v-if="paymentDatum.tooltip"
            :delay="550"
          >
            {{ paymentDatum.tooltip }}
          </q-tooltip>
        </td>
      </tr>
      <tr class="grand-total-row">
        <td>
          Total
        </td>
        <td />
        <td class="cell-value">
          <formatted-number :value="$_(paymentData).map('value').sum()" />
        </td>
      </tr>
    </tbody>
  </q-markup-table>
</template>

<script>

import FormattedDate from 'src/modules/admin/components/FormattedDate.vue'
import FormattedNumber from 'src/modules/admin/components/FormattedNumber'

export default {
  name: 'OrderItemPaymentTable',
  components: { FormattedNumber, FormattedDate },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
    paymentDate: {
      type: Date,
      required: true
    }
  },
  computed: {
    paymentData () {
      const paymentData = []
      const orderItem = this.orderItem

      if (orderItem.paymentDate && orderItem.paymentDate.getTime() === this.paymentDate.getTime()) {
        paymentData.push({
          label: 'Total Due From Customer',
          time: orderItem.paidAt,
          value: orderItem.total
        })
      }

      if (orderItem.refundDate && orderItem.refundDate.getTime() === this.paymentDate.getTime()) {
        paymentData.push({
          label: 'Void of Total Due From Customer',
          time: orderItem.voidedAt,
          value: -orderItem.total
        })
      }

      return paymentData
    }
  },
  configuration: ['currentSite']
}

</script>

<style lang="scss">
th,
.bold-label {
  font-weight: bold;
}

.sub-label {
  padding-left: 1em;
}

.cell-value {
  text-align: right;
}

.total-row td {
  border-top: solid 1px #444;
}

.grand-total-row td {
  font-weight: bold;
  border-top: double 3px #444;
}
</style>
